
















































































































	import { Component, Vue } from "vue-property-decorator";
	import {
  		RedCapital,
  		SelectedCountry,
  		TitleTemplatePublic
	} from "@/configuration";
	import { mapState } from "vuex";

	@Component({
		computed: {
			...mapState(["user"])
		},
		beforeMount(){
			// @ts-ignore
			const dataFiltrada = this.$data.casos.filter(caso => caso.idCaso == this.$data.parametroUrl);
			// @ts-ignore
			if (!dataFiltrada.length)
				this.$router.push('/404');
		},
		data() {
			return{
				casos: [
					{
						idCaso: 1,
						titulo: '“La comunicación con los ejecutivos siempre ha sido muy rápida”',
						nombre: 'José Antonio Otero',
						cargo: 'Socio de Global Seafood',
						foto: '/images/casos/caso_2.png',
						bajada: null,
						contenido: 'Global Seafood es un uno de los principales productores de mariscos en Chile y comenzó a trabajar con RedCapital en mayo de 2016 “Necesitábamos comprar materia prima para comenzar a desarrollarnos y RedCapital nos apoyó. Hemos ido creciendo bastante desde que partimos y hoy ya hemos crecido 4 veces”, puntualiza José Antonio Otero, quien explica además que, últimamente, hicieron un aumento de capital, para continuar desarrollando el negocio.',
						proceso: 'Con RedCapital siempre hemos realizado un proceso de solicitud de financiamiento muy rápido. Independiente que recibamos o no el financiamiento, en una hora siempre nos dan la respuesta positiva o negativa, lo que nos permite no perder el tiempo.',
						atencion: 'La comunicación con los ejecutivos siempre ha sido muy rápida. Uno hace factoring cuando uno tiene necesidad urgente de caja, por lo que realizar factoring con rapidez es esencial en este negocio.',
						tasas: 'Las tasas con las que trabaja RedCapital nos son ni caras ni baratas, son justas en relación con lo que ofrece el mercado. Pero esto, sumado a una excelente atención de los ejecutivos de RedCapital, hace que no tengamos dudas en trabajar con ellos. ¡¡¡RedCapital es nuestra mejor elección!!!',
						fotoFinal: null
					},
					{
						idCaso: 2,
						titulo: '“RedCapital confió en nuestro proyecto y nos apoyó, lo que es muy importante cuando uno está empezando”',
						nombre: 'Francisco Hernández',
						cargo: 'Socio, JBX',
						foto: '/images/casos/caso_3.png',
						bajada: 'Francisco Hernández tiene 37 años de edad y se dice "operado de los nervios". Tuvo varios inconvenientes de los cuales aprendió a ser precavido y rodearse de personas en las que confiara su negocio.',
						contenido: '"JBX es una empresa que le provee maquinaria al sector minero. Cuando partieron trabajando con RedCapital el año 2015, JBX era una empresa que estaba recién partiendo y facturaban alrededor de $20 millones mensuales. El año pasado alcanzaron los US$ 1.000 millones en ventas mensuales, un crecimiento exponencial que han logrado con mucho esfuerzo, trabajo y el apoyo de empresas como RedCapital. “Ellos nos han acompañado en el proceso de crecimiento. Hoy ya estamos consolidados, pero no nos olvidamos de la confianza que depositaron en nosotros”, explica Francisco Hernández.',
						proceso: 'El año 2015 estábamos necesitados de capital y por Google llegamos a RedCapital. Al principio nos contactamos con ellos presencialmente y luego empezamos a trabajar con la empresa vía web, ya que todo resultaba perfectamente. Hemos hecho factoring, solicitudes de crédito y anticipos por Órdenes de Compra. En un principio era muy difícil conseguir financiamiento con los bancos porque nuestras ventas no eran muy altas. Sin embargo, RedCapital confió en nuestro proyecto y nos apoyó, lo que es muy importante cuando uno está empezando.',
						atencion: 'Siempre nos han atendido muy bien. Son años de trabajar juntos, de buenas experiencias, de rapidez en la atención, de confianza mutua y eso se valora.Hoy tenemos una relación de lealtad con ellos, nosotros no trabajamos con otros factoring, porque cuando lo necesitamos, ellos fueron los únicos que confiaron en nosotros y nos prestaron el capital que requeríamos. Así mismo, RedCapital confía en nosotros, en nuestro proyecto y nos acompañan en nuestro crecimiento.',
						tasas: null,
						fotoFinal: null
					},
					{
						idCaso: 3,
						titulo: '“En RedCapital la rapidez es uno de sus pilares y esto realmente se valora”',
						nombre: 'Marcela Osorio',
						cargo: 'Gerente de Finanzas de Dimacril.',
						foto: '/images/casos/caso_1.png',
						bajada: null,
						contenido: 'Dimacril es una Pyme que se dedica a la publicidad y producción de imágenes publicitarias. “Partimos hace unos 5 años, igual que RedCapital. Cuando nace un emprendimiento no muchos confían en ti y RedCapital sí lo hizo y nos ha apoyado desde un inicio”, explica. En el comienzo Dimacril solo producía letreros luminosos, hoy ha ampliado el rubro y captado nuevos clientes ubicados de Arica a Punta Arenas logrando una facturación promedio mensual de $25 millones.',
						proceso: 'Hay muchas empresas que han cortado los créditos y debemos pagar en efectivo o transferencia los insumos para fabricar y montar artículos publicitarios. El problema de liquidez lo hemos solucionado realizando factoring y en RedCapital realizarlo es algo simple. Los ejecutivos son muy ágiles y formales en su forma de actuar y siempre nos han dado una respuesta, ya sea positiva o negativa, lo que se valora, ya que no nos hacen “perder el tiempo”.',
						atencion: 'Realizar factoring con bancos es un proceso muy lento que puede durar 90 días y cuando uno realiza factoring es porque necesita el dinero urgentemente. En RedCapital la rapidez es uno de sus pilares y esto realmente se valora.Trabajar con RedCapital es tener una relación de confianza. Yo puedo llegar allá y hablar con los dueños y explicar mi situación y analizar diferentes vías para resolver diversas situaciones y conflictos puntuales. Ellos nos han apoyado en el proceso de crecimiento y de afiatarnos en el mercado. Han venido otras entidades financieras a ofrecer sus servicios, pero la verdad, no me voy a cambiar de factoring por 1 pto más o 1 punto menos en la tasa. RedCapital nos apoyó desde el primer día y eso es lo que valoramos.',
						tasas: null,
						fotoFinal: '/images/Marcela-caso-2.jpg'
					}
				],
				parametroUrl: this.$route.params.idCaso
			}
		},
		metaInfo() {
			return {
				title: "Caso de estudio",
				titleTemplate: TitleTemplatePublic,
				htmlAttrs: {
					// @ts-ignore
					lang: RedCapital[SelectedCountry].Lang
				}
			};
		}
	})
	export default class StudyCase1 extends Vue {}
